import { ErrorModel } from "../../models/ErrorModel";
import { LOG_ERROR } from "../actions";
import { ActionTypes } from "../actions/types";

const INITIAL_STATE: ErrorModel[] = [];

export const errorsReducer = (state = INITIAL_STATE, action: ActionTypes) => {
    switch (action.type) {
        case LOG_ERROR: {
            const { error } = action;
            if (!state.some((s) => s.error === error)) return state.concat({ error });
            return state;
        }
        default:
            return state;
    }
};
